import { Injectable } from '@angular/core';
import { catchError, map, Observable, Subscriber, throwError } from 'rxjs';
import { ApiRestService } from 'src/app/Services/api-rest.service';
import { Principal, PrincipalAdapter } from 'src/app/Models/Principal/principal';
import { UserProfile } from 'src/app/Models/user-profile';
import { SchoolType } from 'src/app/Models/School/school-type';
import { School } from 'src/app/Models/School/school';

@Injectable({
  providedIn: 'root'
})
export class PrincipalService {
  private apiCallBase = '/SPSchoolsMasterInfo_Get';
  private apiCallCategory = 'Schools Master';
  userInfo: UserProfile;
  userPNumber: string = "";
  schoolType: SchoolType = new SchoolType();
  schoolTypeList: SchoolType[];
  schoolList: School[];
  currentUserInfo: UserProfile;
  principalInfo: Principal;
  principalList: Principal[];

  constructor(private apiRestService: ApiRestService
    , private adapter : PrincipalAdapter) { }

    getSchoolTypeUserPrincipalInfo(apiCallParam: string) {
      // this.spSchoolsMasterInfo_Get(apiCallParam);
      var apiCall = this.apiCallBase + apiCallParam;
      return this.apiRestService.getJasonRestApi(apiCall, this.apiCallCategory).pipe(
        catchError(error => {
          return throwError(error || 'something went wrong for SPSchoolsMasterInfo_Get');
        })
      );
    }

    private spSchoolsMasterInfo_Get(urlParam: string) {
      var apiCall = this.apiCallBase + urlParam;
      this.apiRestService.getJasonRestApi(apiCall, this.apiCallCategory).pipe(
        map(
          data => {
            this.schoolTypeList = data['Table'];
            this.schoolList = data['Table1'];
            this.currentUserInfo = data['Table2'];
            this.principalList = data['Table3'];
          }
        ));
    }

    private getUserInfoStorage() {
      // let userInfoStorage = localStorage.getItem('UserInfo');
      this.userInfo = JSON.parse(localStorage.getItem('UserInfo')!);
      if (this.userInfo === undefined || this.userInfo === null) {
        //this.userInfo = {};
        this.userInfo = null!;
      }
      else {
        this.userPNumber = this.userInfo.userPrincipalName!;
      }
      return this.userInfo;
    }
}
